import styled from "styled-components";
export const FormFieldsetContainer = styled.fieldset.withConfig({
  displayName: "formstyles__FormFieldsetContainer",
  componentId: "sc-oyfn3p-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  borderWidth: "0px",
  borderColor: "rgba(0, 0, 0, 0)",
  flex: "1 1 0%"
});
export const FormContentContainer = styled.div.withConfig({
  displayName: "formstyles__FormContentContainer",
  componentId: "sc-oyfn3p-1"
})(["", " > div.MuiFormControl-root{", "}"], {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, {
  marginBottom: "1rem"
});
export const FormActionsContainer = styled.div.withConfig({
  displayName: "formstyles__FormActionsContainer",
  componentId: "sc-oyfn3p-2"
})(["", " > *{", " &:first-child{", "}}"], {
  display: "flex",
  justifyContent: "center",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  paddingTop: "2rem",
  paddingBottom: "2rem",
  width: "100%"
}, {
  marginLeft: "1rem"
}, {
  marginLeft: "0px"
});
export const ButtonSubmitContent = styled.span.withConfig({
  displayName: "formstyles__ButtonSubmitContent",
  componentId: "sc-oyfn3p-3"
})([""]);
export const ProgressContainer = styled.div.withConfig({
  displayName: "formstyles__ProgressContainer",
  componentId: "sc-oyfn3p-4"
})(["", " top:20%;left:calc(1.3rem * 1.5);"], {
  position: "absolute"
});
export const ButtonSubmitContainer = styled.div.withConfig({
  displayName: "formstyles__ButtonSubmitContainer",
  componentId: "sc-oyfn3p-5"
})(["", " ", "{", "}", "{", "}"], {
  position: "relative"
}, ButtonSubmitContent, ({
  isSubmitting
}) => isSubmitting && {
  opacity: "0.5"
}, ProgressContainer, ({
  isSubmitting
}) => !isSubmitting && {
  display: "none"
});
export const FormHtmlContainer = styled.form.withConfig({
  displayName: "formstyles__FormHtmlContainer",
  componentId: "sc-oyfn3p-6"
})(["", ""], {
  display: "flex",
  width: "100%"
});
